import { i18n, type Messages } from '@lingui/core';

export const locales: Record<string, string> = {
  tr: 'Türkçe',
  en: 'English',
  pl: 'Polski',
};

export type Locale = keyof typeof locales;

export const defaultLocale: Locale = 'tr';

async function loadLocaleMessages(locale: Locale): Promise<Messages> {
  try {
    const mod = (await import(`./locales/${locale}/messages.po`)) as { messages: Messages };
    return mod.messages;
  } catch {
    const mod = (await import(`./locales/${locale}/messages.js`)) as {
      messages?: Messages;
      default?: { messages?: Messages } | Messages;
    };
    if (mod.messages) return mod.messages;
    if (mod.default && 'messages' in mod.default) return mod.default.messages as Messages;
    return mod.default as Messages;
  }
}

export async function dynamicActivate(locale: Locale) {
  const messages = await loadLocaleMessages(locale);
  i18n.loadAndActivate({ locale, messages });
}
